// Reviews: filter chips, histogram filter, sort, "Load more", helpful votes and
// the photo lightbox. Every list is plain HTML first: without this file all
// cards show and the tools stay hidden.
(function () {
  if (window.nReviewsBound) return;
  window.nReviewsBound = true;

  class NReviews {
    constructor(root) {
      this.root = root;
      this.list = root.querySelector('[data-n-review-list]');
      if (!this.list) return;
      this.cards = Array.from(this.list.querySelectorAll('[data-n-review]'));
      this.perPage = Number(this.list.dataset.perPage) || 6;
      this.shown = this.perPage;
      this.state = { filter: 'all', flavor: '', product: '', rating: 0, sort: 'helpful' };
      this.more = root.querySelector('[data-n-load-more]');
      this.status = root.querySelector('[data-n-status]');
      this.nomatch = root.querySelector('[data-n-nomatch]');
      this.ratingChip = root.querySelector('[data-n-rating-chip]');

      const tools = root.querySelector('[data-n-tools]');
      if (tools) tools.hidden = false;
      root.classList.add('is-enhanced');

      root.addEventListener('click', (event) => this.onClick(event));
      const sort = root.querySelector('[data-n-sort]');
      if (sort) sort.addEventListener('change', () => this.update({ sort: sort.value }));
      const product = root.querySelector('[data-n-filter-product]');
      if (product) product.addEventListener('change', () => this.update({ product: product.value }));
      this.update({}, true);
      // CSS hides "more" cards until this runs (no layout shift); from here the hidden attribute rules.
      this.cards.forEach((c) => c.classList.remove('n-rcard--more'));
    }

    onClick(event) {
      const t = event.target.closest('button');
      if (!t || !this.root.contains(t)) return;
      if (t.matches('[data-n-filter]')) {
        const f = t.dataset.nFilter;
        if (f === 'all') {
          const product = this.root.querySelector('[data-n-filter-product]');
          if (product) product.value = '';
          this.update({ filter: 'all', flavor: '', rating: 0, product: '' });
        } else {
          this.update({ filter: this.state.filter === f ? 'all' : f });
        }
      } else if (t.matches('[data-n-filter-flavor]')) {
        const v = t.dataset.nFilterFlavor;
        this.update({ flavor: this.state.flavor === v ? '' : v });
      } else if (t.matches('[data-n-filter-rating]')) {
        const r = Number(t.dataset.nFilterRating);
        this.update({ rating: this.state.rating === r ? 0 : r });
        const list = this.list.getBoundingClientRect();
        if (list.top > window.innerHeight * 0.8) this.list.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else if (t.matches('[data-n-rating-chip]')) {
        this.update({ rating: 0 });
      } else if (t.matches('[data-n-load-more]')) {
        this.shown += this.perPage;
        this.render();
        const next = this.visible[this.shown - this.perPage];
        const first = next && next.querySelector('.n-rcard__title, .n-rcard__body p');
        if (first) {
          first.setAttribute('tabindex', '-1');
          first.focus({ preventScroll: true });
        }
      } else if (t.matches('[data-n-helpful]')) {
        const pressed = t.getAttribute('aria-pressed') === 'true';
        const count = t.querySelector('[data-n-helpful-count]');
        if (count) count.textContent = String(Number(count.textContent) + (pressed ? -1 : 1));
        t.setAttribute('aria-pressed', String(!pressed));
      }
    }

    update(patch, initial) {
      Object.assign(this.state, patch);
      if (!initial) this.shown = this.perPage;
      const s = this.state;
      this.visible = this.cards.filter((c) => {
        if (s.filter === 'photos' && Number(c.dataset.photos) === 0) return false;
        if (s.flavor && c.dataset.flavor !== s.flavor) return false;
        if (s.product && c.dataset.product !== s.product && c.dataset.group !== s.product) return false;
        if (s.rating && Number(c.dataset.rating) !== s.rating) return false;
        return true;
      });
      const by = {
        helpful: (a, b) => b.dataset.helpful - a.dataset.helpful || b.dataset.date - a.dataset.date,
        recent: (a, b) => b.dataset.date - a.dataset.date,
        photos: (a, b) => b.dataset.photos - a.dataset.photos || b.dataset.helpful - a.dataset.helpful,
        high: (a, b) => b.dataset.rating - a.dataset.rating || b.dataset.helpful - a.dataset.helpful,
        low: (a, b) => a.dataset.rating - b.dataset.rating || b.dataset.helpful - a.dataset.helpful,
      }[s.sort] || (() => 0);
      this.visible.sort(by);
      this.visible.forEach((c) => this.list.appendChild(c));
      this.cards.filter((c) => !this.visible.includes(c)).forEach((c) => this.list.appendChild(c));

      this.root.querySelectorAll('[data-n-filter]').forEach((b) => {
        const f = b.dataset.nFilter;
        const on = f === 'all' ? s.filter === 'all' && !s.flavor && !s.rating && !s.product : s.filter === f;
        if (b.hasAttribute('aria-pressed')) b.setAttribute('aria-pressed', String(on));
      });
      this.root.querySelectorAll('[data-n-filter-flavor]').forEach((b) => {
        b.setAttribute('aria-pressed', String(b.dataset.nFilterFlavor === s.flavor));
      });
      this.root.querySelectorAll('[data-n-filter-rating]').forEach((b) => {
        b.setAttribute('aria-pressed', String(Number(b.dataset.nFilterRating) === s.rating));
      });
      if (this.ratingChip) {
        this.ratingChip.hidden = !s.rating;
        const label = this.ratingChip.querySelector('[data-n-rating-chip-label]');
        if (label) label.textContent = s.rating ? `${s.rating} star${s.rating > 1 ? 's' : ''}` : '';
      }
      this.render(initial);
    }

    render(initial) {
      this.cards.forEach((c) => {
        c.hidden = true;
      });
      this.visible.forEach((c, i) => {
        c.hidden = i >= this.shown;
      });
      if (this.more) this.more.hidden = this.visible.length <= this.shown;
      if (this.nomatch) this.nomatch.hidden = this.visible.length > 0;
      if (this.status && !initial) {
        const n = this.visible.length;
        this.status.textContent = `${n} review${n === 1 ? '' : 's'} shown`;
      }
    }
  }

  // Photo lightbox for review photos and UGC tiles: a native <dialog>. Without
  // JS (or without <dialog>) the links open the image itself.
  let dialog;
  function lightbox(link) {
    if (!window.HTMLDialogElement) return false;
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'n-lightbox';
      dialog.innerHTML =
        '<button type="button" class="n-lightbox__close" aria-label="Close">×</button><figure class="n-lightbox__figure"><img class="n-lightbox__img" alt=""><video class="n-lightbox__img" controls playsinline loop hidden></video><figcaption class="n-lightbox__caption"></figcaption></figure>';
      document.body.appendChild(dialog);
      dialog.addEventListener('click', (e) => {
        if (e.target === dialog || e.target.closest('.n-lightbox__close')) dialog.close();
      });
      dialog.addEventListener('close', () => {
        const v = dialog.querySelector('video');
        v.pause();
        v.removeAttribute('src');
      });
    }
    const img = dialog.querySelector('img');
    const video = dialog.querySelector('video');
    const thumb = link.querySelector('img');
    const isVideo = Boolean(link.dataset.nVideo);
    img.hidden = isVideo;
    video.hidden = !isVideo;
    if (isVideo) {
      video.src = link.dataset.nVideo;
      video.setAttribute('aria-label', thumb ? thumb.alt : 'Customer video');
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reduce) video.play().catch(() => {});
    } else {
      img.src = link.href;
      img.alt = thumb ? thumb.alt : '';
    }
    dialog.querySelector('figcaption').textContent = link.dataset.nCaption || '';
    dialog.showModal();
    return true;
  }
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[data-n-lightbox]');
    if (!link) return;
    if (lightbox(link)) event.preventDefault();
  });

  const init = () => document.querySelectorAll('[data-n-reviews]').forEach((root) => {
    if (!root.nReviews) root.nReviews = new NReviews(root);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
